module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-right-circle-fill-d482b8af.svg";